import * as React from 'react'
import { cn } from '@/lib/utils'

/* Skeleton matches the final content height so data arrival causes no layout shift. */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden="true"
      className={cn('animate-pulse rounded-sm bg-surface-subtle', className)}
      {...props}
    />
  )
}

export { Skeleton }
